import { NgModule } from '@angular/core';
// import { InputTextModule } from 'primeng/inputtext';


@NgModule({
  declarations: [],
  exports: [
    // InputTextModule
  ]
})
export class PrimeModule { }
